import React from "react";

const WHATSAPP_NUMBER = "916261007909";

const exportProducts = [
  { name: "Whole Milk Powder",       packSize: "25 Kg" },
  { name: "Full Cream Milk Powder",  packSize: "25 Kg" },
  { name: "Skimmed Milk Powder",     packSize: "25 Kg" },
  { name: "Sweet Whey Powder",       packSize: "25 Kg" },
  { name: "Dairy Whitener",          packSize: "25 Kg" },
  { name: "Unsalted Butter",         packSize: "25 Kg" },
];

const waLink   = `https://wa.me/916261007909?text=${encodeURIComponent("Hello Arihant Milk Products, I am interested in your export/import products. Please share more details.")}`;
const waCat    = `https://wa.me/916261007909?text=${encodeURIComponent("Hello Arihant Milk Products, I would like to request your product catalogue with specifications and pricing.")}`;
const waPartner= `https://wa.me/916261007909?text=${encodeURIComponent("Hello Arihant Milk Products, I am interested in becoming a B2B distributor/partner. Please share details.")}`;
function WAButton({ href, children, dark = false }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center justify-center gap-2 font-bold px-7 py-3 rounded-full transition shadow-md ${
        dark
          ? "bg-green-600 hover:bg-green-500 text-white"
          : "bg-green-600 hover:bg-green-500 text-white"
      }`}
    >
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
        <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.121 1.529 5.849L0 24l6.335-1.51A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.882a9.882 9.882 0 01-5.034-1.374l-.361-.214-3.741.982.998-3.648-.235-.374A9.886 9.886 0 012.118 12C2.118 6.58 6.58 2.118 12 2.118c5.421 0 9.882 4.462 9.882 9.882 0 5.421-4.461 9.882-9.882 9.882z" />
      </svg>
      {children}
    </a>
  );
}

export default function Exports() {
  return (
    <div className="min-h-screen bg-white">

      {/* ── Hero ── */}
      <section
        className="relative overflow-hidden py-20 px-4 text-center text-white"
        style={{ background: "linear-gradient(135deg,#7f1d1d 0%,#b91c1c 55%,#dc2626 100%)" }}
      >
        <div className="absolute top-0 right-0 w-64 h-64 rounded-full pointer-events-none"
          style={{ background: "rgba(255,255,255,0.05)", transform: "translate(30%,-30%)" }} />
        <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full pointer-events-none"
          style={{ background: "rgba(255,255,255,0.04)", transform: "translate(-30%,30%)" }} />
        <div className="relative max-w-3xl mx-auto">
          <span className="inline-block border border-white border-opacity-25 bg-white bg-opacity-10 text-white text-xs font-semibold uppercase tracking-widest px-4 py-1 rounded-full mb-5">
            Export &amp; Import Division
          </span>
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4 leading-tight text-white">
            Global Dairy <span className="text-red-200">Trade</span>
          </h1>
          <p className="text-white text-opacity-90 text-base max-w-xl mx-auto mb-8 leading-relaxed">
            Premium industrial and export-grade dairy products from India.
            We export worldwide and welcome international distributors and B2B partners.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <WAButton href={waLink}>Chat on WhatsApp</WAButton>
            <a
              href={waCat}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 border-2 border-white border-opacity-50 text-white font-semibold px-8 py-3 rounded-full hover:bg-red-700 transition"
            >
              📄 Request Catalogue
            </a>
          </div>
        </div>
      </section>

      {/* ── Stats ── */}
      <section className="grid grid-cols-2 md:grid-cols-4 bg-red-50 border-b border-red-100">
        {[
          { n: "6+",     l: "Products" },
          { n: "25+",    l: "Years Experience" },
          { n: "Global", l: "Export & Import" },
          { n: "B2B",    l: "Industrial Grade" },
        ].map((s) => (
          <div key={s.l} className="py-5 text-center border-r border-red-100 last:border-r-0">
            <div className="text-2xl font-extrabold text-red-700">{s.n}</div>
            <div className="text-xs text-gray-400 uppercase tracking-wider mt-1">{s.l}</div>
          </div>
        ))}
      </section>

      {/* ── Export Products Table ── */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-extrabold text-gray-900 mb-2">Our Export Products</h2>
            <p className="text-gray-400 text-sm">Available for international B2B orders — pricing customizable</p>
            <div className="w-10 h-1 bg-red-600 rounded-full mx-auto mt-3" />
          </div>
          <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-sm">
            <table className="w-full text-sm">
              <thead style={{ background: "#b91c1c" }}>
                <tr>
                  <th className="text-left px-6 py-4 text-white font-bold text-xs uppercase tracking-wider">Product Name</th>
                  <th className="text-left px-6 py-4 text-white font-bold text-xs uppercase tracking-wider">Pack Size</th>
                </tr>
              </thead>
              <tbody>
                {exportProducts.map((p, i) => (
                  <tr key={i} className={`border-b border-gray-100 hover:bg-red-50 transition ${i % 2 === 0 ? "bg-white" : "bg-gray-50"}`}>
                    <td className="px-6 py-4 font-semibold text-gray-800">{p.name}</td>
                    <td className="px-6 py-4 text-gray-500">{p.packSize}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="text-center text-sm text-gray-400 mt-4">
            Need custom packing or quantities?{" "}
            <a href={waLink} target="_blank" rel="noopener noreferrer" className="text-green-600 font-semibold hover:underline">
              Ask on WhatsApp
            </a>
          </p>
        </div>
      </section>

      {/* ── B2B Partners — white background ── */}
      <section className="bg-gray-50 py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block bg-red-100 text-red-700 text-xs font-bold uppercase tracking-widest px-4 py-1 rounded-full mb-4">
            Global Partnerships
          </span>
          <h2 className="text-3xl font-extrabold text-gray-900 mb-4">🌍 Looking for Partners Worldwide</h2>
          <p className="text-gray-500 text-sm max-w-2xl mx-auto mb-8 leading-relaxed">
            We are actively seeking{" "}
            <strong className="text-gray-800">B2B buyers, distributors, and business partners across all countries.</strong>{" "}
            Retail chains, food manufacturers, wholesalers — all welcome.
          </p>
          <div className="flex flex-wrap gap-3 justify-center mb-10">
            {["🏪 Retail Distributors","🏭 Food Manufacturers","📦 Wholesalers","🤝 Import Partners","🌐 All Countries Welcome"].map((tag) => (
              <span key={tag} className="bg-white border border-gray-200 text-gray-600 text-xs px-4 py-2 rounded-full shadow-sm">{tag}</span>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 max-w-2xl mx-auto mb-10">
            {[
              { icon: "📋", title: "Share Requirements", desc: "Tell us products, quantity & destination country" },
              { icon: "🤝", title: "We Negotiate",       desc: "Pricing, packaging & delivery terms" },
              { icon: "🚢", title: "We Deliver",         desc: "Full documentation & export certifications" },
            ].map((s) => (
              <div key={s.title} className="bg-white border border-gray-200 rounded-2xl p-6 text-center shadow-sm">
                <div className="text-3xl mb-3">{s.icon}</div>
                <div className="font-bold text-gray-800 text-sm mb-2">{s.title}</div>
                <div className="text-gray-400 text-xs leading-relaxed">{s.desc}</div>
              </div>
            ))}
          </div>
          <WAButton href={waPartner}>Become a Partner on WhatsApp</WAButton>
        </div>
      </section>

      {/* ── Catalogue — white background ── */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-xl mx-auto text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 mb-2">Product Catalogue</h2>
          <p className="text-gray-400 text-sm mb-8">Full specs, MOQ and certifications</p>
          <div className="border-2 border-dashed border-red-200 bg-red-50 rounded-2xl p-10">
            <div className="text-5xl mb-4">📄</div>
            <h3 className="text-xl font-extrabold text-gray-800 mb-3">Arihant Export Catalogue</h3>
            <p className="text-gray-500 text-sm mb-6 leading-relaxed">
              Request our complete product catalogue with full specifications,
              certifications and minimum order quantities — sent directly via WhatsApp.
            </p>
            <WAButton href={waCat}>Request via WhatsApp</WAButton>
          </div>
        </div>
      </section>

      {/* ── Final CTA ── */}
      <section className="bg-red-700 py-16 px-4 text-center">
        <h2 className="text-3xl font-extrabold text-white mb-3">Ready to Start Trading?</h2>
        <p className="text-white text-opacity-80 text-sm mb-8">
          Message us for pricing, MOQ and shipping details. We reply fast.
        </p>
        <WAButton href={waLink}>Chat on WhatsApp — +91 62610 07909</WAButton>
      </section>

    </div>
  );
}
